<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <div class="search-left">
                    <el-form :inline="true" :model="query">
                        <!-- <el-form-item>
                            <el-select v-model="query.role_id" filterable multiple collapse-tags placeholder="所属角色" class="handle-select mr10">
                                <el-option v-for="(row, index) in roleList" :key="index" :label="row.title" :value="row.id"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item>
                            <el-input v-model="query.keywords" placeholder="昵称、真实姓名或者手机号" clearable @clear="handleSearch" class="handle-input mr10"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="handleSearch">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <!-- 上传表格 S -->
        <el-table :data="customerData" class="table-user" v-loading="loading" :height="tableHeight" :max-height="tableHeight">
            <!-- <el-table-column prop="id" label="编号" width="50"> </el-table-column> -->
            <el-table-column prop="realname" label="员工姓名" width="220" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    {{scope.row.user &&scope.row.user.realname}}
                </template>
            </el-table-column>
            <el-table-column prop="" label="微信信息" width="250" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    <div class="wechatInfo" @click="showDrawerPass(_self, 'wechatDetail', 'wechatShowDialog', [scope.row,'userWechatList'])">
                        <div class="avatar"><img :src="scope.row.head_img" alt=""></div>
                        <div class="nickname">{{scope.row.nick_name}}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="mobile" width="150" label="手机号" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    {{scope.row.user &&scope.row.user.mobile}}
                </template>
            </el-table-column>
            <el-table-column prop="is_valid" label="在职状态" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    <el-tag type="primary">{{ scope.row.user &&scope.row.user.is_valid == 1 ? '在职' : '离职' }}</el-tag>
                </template>
            </el-table-column>
        </el-table>
        <!-- 上传表格 E -->
        <div class="footer-box">
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10, 15, 30, 50, 100, 300, 1000]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
            </div>
        </div>
        <wechat-detail ref="wechatDetail" :parent="_self"></wechat-detail>
    </div>
</template>

<script>
import {
    showDrawerPass
} from '@/utils/common.js';
// 订单信息
import wechatDetail from '@/components/wechat/index.vue'
const filterItem = {
    department_id: '',
    role_id: [],
    keywords: '',
    is_valid: "1"
};
export default {
    components: {
        wechatDetail
    },
    data() {
        let tableHeight = window.innerHeight - 300;
        let windowheight = window.innerHeight;
        return {
            loading: false,
            tableHeight: tableHeight,
            windowheight: windowheight,
            customerData: [],
            roleList: [],
            query: Object.assign({}, filterItem),
            //反映翻页
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            }

        }
    },
    created() {
        this.getTableData();
        // 获取角色列表
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
    },
    methods: {
        handleSearch() {
            this.getTableData()
        },
        // 获取列表数据
        getTableData() {
            let that = this;
            let url = '/api/customer.member/getUserWechat';
            let query = this.query;
            query['pagination'] = that.pagination;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.customerData = result.tableData;
                that.pagination = result.pagination;
            });
        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
    }

}
</script>

<style lang="less">
@import url('@/assets/css/common.less');
.wechatInfo {
    display: flex;
    width: 100px;
    cursor: pointer;
    .avatar {
        width: 25px;
        height: 25px;
        margin-right: 10px;
        img {
            width: 25px;
            height: 25px;
        }
    }
    .nickname {
        flex: 1;
        line-height: 25px;
    }
}
</style>